<script>
  import { whenFastSimonReady } from '@/lib/vue-helpers.js';

  export default {
    name: 'ProductListPromo',
    props: {
      Title: String,
      Image: String,
      Link: String,
      Pid: String,
      productIndex: Number,
      collectionTracking: Boolean,
      collectionId: {
        type: String,
        default: ''
      },
      collectionHandle: {
        type: String,
        default: ''
      },
      searchTerm: {
        type: String,
        default: ''
      },
      width: {
        type: Number,
        default: 1
      },
      height: {
        type: Number,
        default: 1
      },
      mobileImage: {
        type: String,
        default: ''
      }
    },
    computed: {
      isOversized() {
        return this.width > 1 || this.height > 1;
      },
      promoClasses() {
        const classes = ['promo-wrapper'];
        if (this.width > 1) classes.push('promo-wide');
        if (this.height > 1) classes.push('promo-tall');
        return classes;
      },
      activeImage() {
        if (this.mobileImage && window.innerWidth <= (window.theme?.sizes?.medium || 767)) return this.mobileImage;
        return this.Image;
      }
    },
    methods: {
      shouldHaveLink() {
        if (this.Link != '') {
          this.reportPromoTileClick();
          window.location = window.theme.routes.root_url + this.Link;
        }
        return false;
      },
      reportPromoTileClick() {
        if (!this.collectionTracking) return;
        const isSearch = document.querySelector('body').id === 'search-results';
        const position = this.productIndex != null ? this.productIndex + 1 : undefined;
        whenFastSimonReady(() => {
          if (isSearch) {
            window.FastSimonSDK.event({
              eventName: window.FastSimonEventName.SerpPromoTileClicked,
              data: {
                query: this.searchTerm,
                productID: String(this.Pid),
                position: position,
                link: this.Link,
                thumbnail: this.Image
              }
            });
          } else {
            window.FastSimonSDK.event({
              eventName: window.FastSimonEventName.CollectionPromoTileClicked,
              data: {
                collectionID: this.collectionId,
                productID: String(this.Pid),
                position: position,
                query: this.collectionHandle,
                link: this.Link,
                thumbnail: this.Image
              }
            });
          }
        });
      },
      shouldHaveHandClass() {
        if (this.Link != '') {
          return 'product-grid-item__container pointer';
        }
        return 'product-grid-item__container ';
      },
      shouldHideNonUsProducts() {
        if (window.siteGlobals.countryCode == 'US') {
          return true;
        }
        return false;
      }
    }
  };
</script>

<template>
  <div :class="promoClasses" :data-promotion_id="'promo-' + Pid" data-promotion_creative="PLP-Content-Tile" :id="'product-tile-' + Pid" data-promotion_position="PLP-Content-Tile" :data-promotion_name="Title" :data-pid="productIndex" v-if="shouldHideNonUsProducts()">
    <div :class="shouldHaveHandClass()">
      <div class="product-grid-item__images promo-tile" @click="shouldHaveLink()">
        <div :style="{ 'background-image': 'url(' + activeImage + ')' }">&nbsp;</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #fs-collection-products {
    .promo-wrapper {
      position: relative;
      height: 100%;

      .product-grid-item__container {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
      }

      .pointer {
        cursor: pointer;
      }

      &.promo-wide .promo-tile div,
      &.promo-tall .promo-tile div {
        background-position: center center;
        background-size: cover;
      }
    }

    .promo-tile {
      height: 100%;

      div {
        background-position: center center;
        background-size: cover;
        height: 100%;
      }

      img {
        opacity: 0;
      }
    }
  }
</style>
